import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/system/',
    component:layout,
    children:[
        {name: '身份管理', path: 'role', component: ()=>_import('role')},
		{name: '账号管理', path: 'admin', component: ()=>_import('admin')},
		{name: '菜单管理', path: 'menu', component: ()=>_import('menu')},
        // add route here
    ]
}